import { Badge } from "@mantine/core";
import { useInViewport } from "@mantine/hooks";
import { useEffect } from "react";
import { useStopwatch } from "react-timer-hook";

import { useSession } from "@/hooks/@custom/useSession";
import { useAppDispatch } from "@/store";
import { QueueCompany, settingsApi, useGetSettingsByCompanyQuery } from "@/store/apis/nextcargo";
import { cn } from "@/utils/cn";
import { getToleranceTime } from "@/utils/getToleranceTime";

export function ToleranceBadge({ queue }: { queue?: QueueCompany }) {
  const { expedition } = useSession();
  const companyId = expedition?.company.id;
  const { data: settings } = useGetSettingsByCompanyQuery({ id: companyId! }, { skip: !companyId });
  const dispatch = useAppDispatch();

  const { ref, inViewport } = useInViewport();
  const { start, pause, reset } = useStopwatch();

  const { time, isExhausted, isInTolerance } = getToleranceTime({ currentData: queue?.date, toleranceTime: settings?.tolerance });

  useEffect(() => {
    if (!companyId || !queue?.id) return;

    dispatch(
      settingsApi.util.updateQueryData("getSettingsByCompany", { id: companyId }, (draft) => {
        const id = queue.id;
        const exists = draft.$toleranceQueueIds.includes(id);

        if (isInTolerance && !exists) {
          draft.$toleranceQueueIds.push(id);
        }

        if (!isInTolerance && exists) {
          draft.$toleranceQueueIds = draft.$toleranceQueueIds.filter((itemId) => itemId !== id);
        }
      })
    );
  }, [companyId, queue?.id, isInTolerance, settings, time, isExhausted]);

  useEffect(() => {
    if (inViewport) {
      start();
    }
    if (!inViewport) {
      pause();
    }

    if (isExhausted) {
      pause();
    }

    return reset;
  }, [inViewport]);

  if (!isInTolerance && !isExhausted) return null;

  return (
    <Badge color="yellow.6" radius="sm" c="white" classNames={{ label: cn("font-semibold! capitalize!") }} ref={ref}>
      Tolerância • {time}
    </Badge>
  );
}
